import React, { useState, useEffect } from "react";
import { Button, Box, Paper, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Link, useParams } from "react-router-dom";
import { guardAllowedFiles } from '../../../util/fileValidation';


import apiClient from "../../../Api/ApiClient";
import api from "../../../Api/api.json";

import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import TextareaAutosize from "@mui/material/TextareaAutosize";

export const AboutUsEdit = () => {
  const { id } = useParams();

  const [selectedImage, setSelectedImage] = useState(null); // Can be File OR string URL
  const [imageName, setImageName] = useState("");
  const [description, setDescription] = useState("");

  // -----------------------------------
  // LOAD EXISTING DATA
  // -----------------------------------
  useEffect(() => {
    fetchAboutData();
  }, [id]);

  const fetchAboutData = async () => {
    try {
      const res = await apiClient.get(`/api/About/${id}`);

      const data = res.data[0];

      setImageName(data.content || "");
      setDescription(data.description || "");

      // For preview (string image path)
      setSelectedImage(data.imgpath || null);

    } catch (err) {
      console.error("Error fetching data:", err);
      toast.error("Failed to load existing data");
    }
  };

  // -----------------------------------
  // HANDLE IMAGE SELECT
  // -----------------------------------
  const handleVideoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file); // File type
    }
  };

  // -----------------------------------
  // UPDATE DATA
  // -----------------------------------
  const handleVideoUpload = async () => {

    const formData = new FormData();

    // Add image ONLY IF user selected a new one
    if (selectedImage instanceof File) {
      formData.append("imgsrc", selectedImage);
    }

    formData.append("content", imageName);
    formData.append("description", description);

    try {
      await apiClient.post(`/api/About/put/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Updated successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });

    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Update failed", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  // -----------------------------------
  // RENDER IMAGE PREVIEW SAFELY
  // -----------------------------------
  const previewImage =
    selectedImage instanceof File
      ? URL.createObjectURL(selectedImage)
      : selectedImage
      ? `${api.baseURL}/${selectedImage}`
      : null;

  return (
    <div>
      <Header />
      <Sidebar />

      <main id="main" className="main">
        <div className="pagetitle-rgt">
          <Link to="/cms/aboutustable">
            <button type="button" className="btn btn-info">
              Back
            </button>
          </Link>
        </div>

        <form>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <h1>About Us</h1>

            {/* IMAGE PREVIEW */}
            {previewImage && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 2,
                }}
              >
                <img
                  width="120"
                  height="120"
                  style={{
                    maxWidth: "120px",
                    maxHeight: "120px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                  src={previewImage}
                  alt="Preview"
                />
              </Box>
            )}

            {/* FILE UPLOAD */}
            <input
              // type="file"
              // onChange={handleVideoChange}
              type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.zip"
              onChange={guardAllowedFiles(handleVideoChange)}

              style={{ display: "none" }}
              id={`upload-input-${id}`}
            />

            <label htmlFor={`upload-input-${id}`}>
              <Button variant="outlined" component="span">
                <AddPhotoAlternateIcon />
                Choose Image
              </Button>
            </label>

            {/* Title */}
            <TextField
              label="Title"
              value={imageName}
              onChange={(e) => setImageName(e.target.value)}
              fullWidth
              sx={{ marginTop: 2 }}
              required
            />

            {/* Description */}
            <TextareaAutosize
              minRows={3}
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{
                marginTop: 20,
                width: "100%",
                padding: 10,
                borderRadius: 5,
                borderColor: "#ccc",
              }}
              required
            />

            {/* UPDATE BUTTON */}
            <Button
              variant="contained"
              color="primary"
              onClick={handleVideoUpload}
              sx={{ marginTop: 2 }}
            >
              <UploadFileIcon /> Update
            </Button>

            <ToastContainer />
          </Paper>
        </form>
      </main>

      <Footer />
    </div>
  );
};
